import * as React from 'react';
import * as Classes from '../common/classes';
import classNames from 'classnames';
import { IProps } from '../common/props';
import { ReactNode } from 'react';
import { Label } from '../label/Label';

export interface IFormGroupProps extends IProps {
  helperText?: ReactNode;
  label?: ReactNode;
  required?: boolean;
  contentClassName?: string;
  inline?: boolean;
  /**
   * Pokud true, tak se label renderuje vždy, i když je prázdný.
   */
  emptyLabel?: boolean;
}

export type FormGroupProps = IFormGroupProps;

export const FormGroup: React.FC<FormGroupProps> = ({
  className,
  children,
  style,
  title,
  helperText,
  inline,
  required,
  contentClassName,
  dataTest,
  label,
  emptyLabel,
}) => {
  const cls = classNames(Classes.FORM_GROUP, className, {
    [Classes.FORM_GROUP_HAS_HELPER_TEXT]: !!helperText,
    [Classes.FORM_GROUP_INLINE]: inline,
  });

  const labelContent = label || (emptyLabel ? <span>&nbsp;</span> : label);

  return (
    <div
      style={style}
      title={title}
      data-test={dataTest ? `form-grroup-${dataTest}` : undefined}
      className={cls}
    >
      {(label || emptyLabel) && (
        <Label required={required}>{labelContent}</Label>
      )}
      <div className={classNames(Classes.FORM_GROUP_CONTENT, contentClassName)}>
        {children}
        {helperText}
      </div>
    </div>
  );
};
